import AV from 'leancloud-storage'

var APP_ID = 'MovmRmeTjl1i18FkHuXRmW6c-gzGzoHsz'
var APP_KEY = '6iIwVpOPza8RSR42yDleSzUh'
AV.init({
  appId: APP_ID,
  appKey: APP_KEY
})

export default AV



// WEBPACK FOOTER //
// ./src/lib/leancloud.js